import { useState, Fragment, useEffect, useContext } from "react";
import { Grid } from "@mui/material";

import "./ksopParticipantSignature.css";
import { AuthContext } from "../../../../../../../contexts";
/* eslint-disable */

const KsopPartcipantSignature = () => {
	const { member } = useContext(AuthContext);
	return (
		<div className="ksop-participant-signature">
			<div className="ksop-block">
				<div className="side-box">Must Sign</div>
				<div className="content-box-gray">
					<div className="title">Participant Signature</div>

					<div className="content" style={{ fontSize: "14px" }}>
						<b style={{ paddingLeft: "5px" }}>
							This designation revokes all prior designations made under the plan.
						</b>
						<Grid container spacing={0}>
							<Grid item xs={4} className="inside-item-border3">
								<mark>Participant Signature (Required)</mark>
								<p>{member?.first_name + " " + member?.last_name}</p>
							</Grid>
							<Grid item xs={4} className="inside-item-border3">
								<mark>Date</mark>
								<p>
									{new Date().getMonth() +
										1 +
										"/" +
										new Date().getDate() +
										"/" +
										new Date().getFullYear()}
								</p>
							</Grid>
							<Grid item xs={4} className="inside-item-border3">
								Received and filed by Principal Life Ins. Co.
								<p>
									<b>Date Received</b>
									<input
										className="input-bottom-border"
										type="text"
										placeholder="MM/DD/YYYY"
										disabled
									></input>
								</p>
							</Grid>
						</Grid>
						<p style={{ paddingLeft: "5px" }}>
							UNDER THE PENALTIES OF PERJURY, I certify by my signature that all of the information on
							this Beneficiary Designation form is true, current, and complete.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KsopPartcipantSignature;
